import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import './scoresDropDown.scss';
import EScoringGroup from 'enums/EScoringGroup';
import { useRMSelector } from 'redux/hooks';
import { selectScoreGroup } from 'redux/selectors/StateSelectors';
import { setHeaderScoresGroupType } from 'redux/reducers/headerReducer';
import { IoMdArrowDropdown } from 'react-icons/io';
import { rwidth } from '../../utils/ResponsiveUtils';
export default function ScoresDropDown({
  defaultText,
  optionsList,
  dropdownHeight,
  dropdownwidth,
}) {
  const scoreGroup = useRMSelector(selectScoreGroup);
  const [showOptionsList, setShowOptionsList] = useState(false);
  const [defaultSelected, setDefaultSelected] = useState(getScoreGroupName(scoreGroup));

  const dispatch = useDispatch();

  const manualScoreGroups = optionsList.filter(
    (scoregroup) => scoregroup.isAutoScore === false,
  );
  const autoScoreGroups = optionsList.filter(
    (scoregroup) => scoregroup.isAutoScore === true,
  );
  useEffect(() => {
    function handleClickOutside(e) {
      if (
        !e.target.classList.contains('score-select-item') &&
        !e.target.classList.contains('select-scores-top') &&
        !e.target.classList.contains('select-scores-selected') &&
        !e.target.classList.contains('scores-arrow') &&
        !e.target.classList.contains('scores-arrow-img') &&
        !e.target.classList.contains('score-select-body') &&
        !e.target.classList.contains('select-scores') &&
        !e.target.classList.contains('scores-ul')
      ) {
        setShowOptionsList(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
  useEffect(() => {
    const groupName = getScoreGroupName(scoreGroup);
    setDefaultSelected(groupName);
  }, [scoreGroup]);
  function getScoreGroupsView(scoresType, scoreGroups, isManual = false) {
    const groupName: string = getScoreGroupName(scoresType);
    const identifier = groupName.toLowerCase();
    return (
      <>
        <option
          id={`scoredropdown-option-${identifier}`}
          data-testid={`scoredropdown-option-${identifier}`}
          className="score-select-item"
          style={{ fontWeight: 700, cursor: 'pointer' }}
          value={scoresType}
          onClick={handleOptionsClick}
        >
          {`${groupName} Scores`}
        </option>
        {scoreGroups.map((scoregroup, index) => {
          return (
            <option
              key={index}
              id={`scoredropdown-option-${identifier}-${index}`}
              data-testid={`scoredropdown-option-${identifier}-${index}`}
              className={'score-select-item cursor-pointer'}
              style={{ marginLeft: '20px' }}
              value={scoregroup.scoreGroupsId}
              onClick={handleOptionsClick}
            >
              {scoregroup.name}
            </option>
          );
        })}
      </>
    );
  }

  function getScoreGroupName(scoreId) {
    if (scoreId === EScoringGroup.All) {
      return 'All';
    }
    if (scoreId === EScoringGroup.Manual) {
      return 'Manual';
    }
    if (scoreId === EScoringGroup.Auto) {
      return 'Auto';
    }
    const scrGroup = optionsList.find((option) => option.scoreGroupsId === scoreId);
    return scrGroup ? scrGroup.name : 'All Scores';
  }

  function handleOptionsClick(e) {
    const value = Number(e.target.value);
    setDefaultSelected(getScoreGroupName(value));
    dispatch(setHeaderScoresGroupType(value));
    setShowOptionsList(false);
  }

  function handleListDisplay(e) {
    setShowOptionsList(!showOptionsList);
  }
  return (
    <div
      id="scoredropdown-wrapper"
      data-testid="scoredropdown-wrapper"
      style={{
        border: 1,
        borderColor: '#414042',
        borderStyle: 'solid',
        background: '#ffffff',
        height: dropdownHeight,
        width: dropdownwidth,
      }}
    >
      <div
        id="scoredropdown-header"
        data-testid="scoredropdown-header"
        className="select-scores-top flex-y-center flex-space-between cursor-pointer"
        onClick={handleListDisplay}
      >
        <div
          id="scoredropdown-selected"
          data-testid="scoredropdown-selected"
          className="select-scores-selected flex-y-center"
        >
          {defaultSelected ? `${defaultSelected} Scores` : 'All Scores'}
        </div>
        <div
          id="scoredropdown-dropdown-wrapper"
          data-testid="scoredropdown-dropdown-wrapper"
          className="scores-arrow flex-y-center"
        >
          <IoMdArrowDropdown
            id="scoredropdown-dropdown-button"
            size={'1.2rem'}
            style={{ marginRight: rwidth(13.21) }}
          ></IoMdArrowDropdown>
        </div>
      </div>
      {showOptionsList && (
        <div
          id="scoredropdown-body"
          data-testid="scoredropdown-body"
          className="score-select-body"
        >
          <ul
            id="scoredropdown-list"
            data-testid="scoredropdown-list"
            className="scores-ul"
          >
            <option
              id="scoredropdown-option-all"
              data-testid="scoredropdown-option-all"
              className="score-select-item"
              style={{ fontWeight: 700, cursor: 'pointer' }}
              onClick={handleOptionsClick}
              value={EScoringGroup.All}
            >
              All Scores
            </option>
            {getScoreGroupsView(EScoringGroup.Manual, manualScoreGroups, true)}
            {getScoreGroupsView(EScoringGroup.Auto, autoScoreGroups)}
          </ul>
        </div>
      )}
    </div>
  );
}
